import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import type { VppApplication } from '../../types/vpp-application.types';

@Component({
  selector: 'ml-mdm-vpp-asset-list-item-ui',
  templateUrl: './vpp-asset-list-item.component.html',
  styleUrls: ['./vpp-asset-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FaIconComponent],
})
export class VppAssetListItemComponent {
  public versions: string[] = [];

  readonly asset = input.required<VppApplication>();
}
